@if (field.inputCode === 'date') {
<p-calendar (onSelect)="changedValue($event)" [showIcon]="true" [placeholder]="placeholder"></p-calendar>
}
@else if (multiSelectFields.includes(field.attributeCode)) {
<p-multiSelect appendTo="body" #multiSelect placeholder="{{placeholder}}"
    [options]="field.presetValues"
    [(ngModel)]="selectedValue"
    optionLabel="labelValue"
    [showToggleAll]="true"
    optionValue="labelKey"
    [filter]="true"
    filterPlaceHolder="{{filterPlaceholder}}"
    (onPanelHide)="clearSearchField(multiSelect)"
    (onChange)="changedValue($event)"
    (onSelectAllChange)="onSelectAllChange($event)"
    (onFilter)="onFilter($event)"
    [style]="{'max-width': '600px'}">

    <ng-template pTemplate="filtericon">
        <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
    </ng-template>
</p-multiSelect>
}
@else if(field.attributeCode === 'Parent') {
<p-multiSelect appendTo="body" #multiSelect [placeholder]="'lbl_select_field' | translate: {field:label}"
    [options]="field.presetValues"
    [(ngModel)]="selectedValue"
    optionLabel="labelValue"
    [showToggleAll]="true"
    optionValue="labelKey"
    [filter]="true"
    (onPanelHide)="clearSearchField(multiSelect)"
    (onChange)="changedValue($event)"
    (onFilter)="onFilter($event)"
    [style]="{'max-width': '600px'}"
    [disabled]="field?.disabled">

    <ng-template pTemplate="filtericon">
        <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
    </ng-template>
</p-multiSelect>
} @else {
<p-multiSelect appendTo="body" #multiSelect [placeholder]="'lbl_select_field' | translate: {field:label}"
    [options]="field.presetValues"
    [(ngModel)]="selectedValue"
    optionLabel="labelValue"
    [showToggleAll]="true"
    optionValue="labelKey"
    [filter]="true"
    (onPanelHide)="clearSearchField(multiSelect)"
    (onChange)="changedValue($event)"
    (onSelectAllChange)="onSelectAllChange($event)"
    (onFilter)="onFilter($event)"
    [style]="{'max-width': '600px'}"
    [disabled]="field?.disabled">

    <ng-template pTemplate="filtericon">
        <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
    </ng-template>
</p-multiSelect>
}